import {
    CHANGE_PROGRESS,
    CHANGE_SERVICE_FORM_FIELD,
    CHANGE_SERVICE_FORM_VALIDATION,
    DELETE_SERVICE,
    INIT_SERVICE_FORM_CONTEXT,
    RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD,
    SET_SERVICE_FORM_VALIDATION_ERRORS,
    UPDATE_CLIENT_SERVICE,
    UPDATE_CLIENT_SERVICES,
    UPDATE_SERVICE,
    UPDATE_SERVICES,
    DELETE_CLIENT_SERVICE
} from './available'

import _ from 'lodash'

export default {
    [UPDATE_SERVICES](state, services) {
        state.services = services
        state.servicesById = _.keyBy(services, 'id')
    },
    [UPDATE_SERVICE](state, service) {
        let index = _.findIndex(state.services, function (item) {
            return item.id === service.id
        })

        if (index < 0) {
            return
        }

        state.services.splice(index, 1, service)
        state.servicesById[service.id] = service
    },
    [DELETE_SERVICE](state, serviceData) {
        let index = _.findIndex(state.services, function (item) {
            return item.id === serviceData.id
        })

        if (index < 0) {
            return
        }

        state.services.splice(index, 1)
        delete state.servicesById[serviceData.id]
    },
    [CHANGE_PROGRESS](state, {context, value}) {
        let p =_.cloneDeep(state.progress)
        state.progress = _.set(p, context, value)
    },
    [SET_SERVICE_FORM_VALIDATION_ERRORS](state, {context, value}) {
        _.set(state.serviceFormContexts, [context, 'errorMessagesByFields'], value)
    },
    [RESET_SERVICE_FORM_VALIDATION_ERRORS_BY_FIELD](state, {context, fieldName}) {
        delete state.serviceFormContexts[context]['errorMessagesByFields'][fieldName]
    },
    [INIT_SERVICE_FORM_CONTEXT](state, {context, data, formValid}) {
        _.set(state.serviceFormContexts, context, {
            data: {
                ...data
            },
            errorMessagesByFields: {},
            formValid: formValid || false
        })
    },
    [CHANGE_SERVICE_FORM_FIELD](state, {context, name, value}) {
        let formContext = _.get(state.serviceFormContexts, context, {})

        _.set(state.serviceFormContexts, context, {
            ...formContext,
            data: {
                ...formContext.data,
                [name]: value
            },
        })
    },
    [CHANGE_SERVICE_FORM_VALIDATION](state, {context, value}) {
        let formContext = _.get(state.serviceFormContexts, context, {})

        _.set(state.serviceFormContexts, context, {
            ...formContext,
            formValid: value
        })
    },
    [UPDATE_CLIENT_SERVICES](state, {clientId, clientServices}) {
        if (clientServices.length === 0) {
            return
        }

        state.clientServicesByClientId = {
            ...state.clientServicesByClientId,
            [clientId]: _.keyBy(clientServices, 'serviceId')
        }
    },
    [UPDATE_CLIENT_SERVICE](state, clientService) {
        state.clientServicesByClientId = {
            ...state.clientServicesByClientId,
            [clientService.clientId]: {
                ...state.clientServicesByClientId[clientService.clientId],
                [clientService.serviceId]: clientService
            }
        }
    },
    [DELETE_CLIENT_SERVICE](state, {clientId, serviceId}) {
        let clientServicesByClient = _.cloneDeep(_.get(state.clientServicesByClientId, clientId, {}))
        delete clientServicesByClient[serviceId]

        state.clientServicesByClientId[clientId] = clientServicesByClient
    }
}
